// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const InstanceTrafficPolicyStatus = {
  InstanceTrafficPolicyStatusApplied: 'applied',
  InstanceTrafficPolicyStatusProcessing: 'processing',
  InstanceTrafficPolicyStatusFailed: 'failed',
} as const;
export type InstanceTrafficPolicyStatus =
  (typeof InstanceTrafficPolicyStatus)[keyof typeof InstanceTrafficPolicyStatus];

export function instanceOfInstanceTrafficPolicyStatus(value: any): boolean {
  for (const key in InstanceTrafficPolicyStatus) {
    if (
      Object.prototype.hasOwnProperty.call(InstanceTrafficPolicyStatus, key)
    ) {
      if (
        InstanceTrafficPolicyStatus[
          key as keyof typeof InstanceTrafficPolicyStatus
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function InstanceTrafficPolicyStatusFromJSON(
  json: any,
): InstanceTrafficPolicyStatus {
  return InstanceTrafficPolicyStatusFromJSONTyped(json, false);
}

export function InstanceTrafficPolicyStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InstanceTrafficPolicyStatus {
  return json as InstanceTrafficPolicyStatus;
}

export function InstanceTrafficPolicyStatusToJSON(
  value?: InstanceTrafficPolicyStatus | null,
): any {
  return value as any;
}

export function InstanceTrafficPolicyStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): InstanceTrafficPolicyStatus {
  return value as InstanceTrafficPolicyStatus;
}
